import { Box, Stack, Typography } from "@mui/material";
import { blue } from "@mui/material/colors";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";

export interface ICheckoutHeaderProps {
  height?: string | number;
}

/**
 * Placeholder visual para itens do tipo "none" (header/guia).
 * Usa o mesmo design das drop zones (topo/rodapé/lateral)
 * para manter consistência visual no builder.
 */
const CheckoutHeader = ({ height = 48 }: ICheckoutHeaderProps) => {
  return (
    <Box
      sx={{
        width: "100%",
        height: height,
        border: `2px dashed ${blue[500]}`,
        borderRadius: "8px",
        backgroundColor: blue[50],
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Stack
        direction="row"
        spacing={1}
        alignItems="center"
        sx={{ pointerEvents: "none" }}
      >
        <AddCircleOutlineIcon sx={{ color: blue[500], fontSize: 18 }} />
        <Typography variant="caption" sx={{ color: blue[700], fontWeight: 500 }}>
          Arraste um componente aqui
        </Typography>
      </Stack>
    </Box>
  );
};

export default CheckoutHeader;
